import { SweetAlert2Wrapper } from '@common/sweet-alert-wrapper';

const defaults = {
    title: "Let's Confirm",
    icon: 'warning',
    showCancelButton: true,
    cancelButtonText: 'Cancel',
};

class Confirm extends SweetAlert2Wrapper {
    constructor(params) {
        super();
        this.required = ['text', 'confirmButtonText'];
        this.optional = ['title', 'icon', 'cancelButtonText', 'width'];
        this.allowed = [...this.required, ...this.optional];
        try {
            this.config = Object.assign({}, defaults, this.validate(params));
            this.setTextAsHTML();
        } catch (ex) {
            // Log exception to console here so message doesnt get lost in .then and never seen

            console.error(ex);

            throw ex;
        }
    }
}

/**
 * @function confirm
 * @param {object} params requires properties of 'title', 'text', 'confirmButtonText',
 * properties 'icon' and 'cancelButtonText' are optional
 * @returns {object} Returns a promise that is resolved only on confirm
 */
export function confirm(params) {
    return new Promise((resolve, reject) => {
        const c = new Confirm(params);
        c.show().then((result) => {
            if (result.value) {
                resolve(result.value);
            } else {
                reject(result.dismiss);
            }
        });
    });
}
